/* eslint-disable react-hooks/rules-of-hooks */
import { useMediaQuery } from "@mui/material";

export const getMobileBool = () => {
  return useMediaQuery('(max-width:900px)')
}